import { getApi } from "../../../services/api";

export const getProfileById = (id) => {
  return getApi(`/${id}/profile`, "/api/v1");
};
